import React from "react";

const WhyChooseStaff: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full">
      <div className="grid gap-5">
        <div className="grid gap-5 grid-cols-2 md:grid-cols-3 xl:gap-12">
          <div className="p-3">
            <h4 className=" font-light text-3xl lg:text-4xl max-w-xs xl:leading-normal">
              Why Choose Dream Weavers Staffing Solution?
            </h4>
          </div>

          <div className="flex flex-col gap-1 md:gap-3 custom-hover bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              01
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              Simplified Workforce Management
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              We take the hassle out of managing your workforce, handling
              recruitment, onboarding, payroll, and compliance, so you can focus
              on your core business objectives.
            </p>
          </div>
          <div className="flex flex-col gap-1 custom-hover md:gap-3 bg-[#34368A] text-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl">
              02
            </h3>
            <div className="font-medium xl:text-xl">
              Flexible Solutions Tailored to Your Business Needs
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Our staffing services adapt to your unique requirements, whether
              you need temporary, permanent, or project-based staffing
              solutions.
            </p>
          </div>
          <div className="flex flex-col gap-1 md:gap-3 custom-hover bg-white rounded-lg p-5 xl:py-8">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              03
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              Reduced Administrative Burden and Costs
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              By outsourcing workforce management, you save time and operational
              costs associated with HR processes, employee benefits, and
              regulatory compliance.
            </p>
          </div>
          <div className="flex flex-col gap-1 md:gap-3 custom-hover bg-white rounded-lg p-5">
            <h3 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-4xl text-[#34368A]">
              04
            </h3>
            <div className="font-medium text-[#5C5C5C] xl:text-xl">
              Access to a Skilled and Reliable Talent Pool
            </div>
            <p className="flex-1 text-xs font-light xl:text-base leading-normal">
              Leverage our vast network of qualified professionals to quickly
              find the right talent with the expertise you need to drive your
              business forward.
            </p>
          </div>
          <div className="flex w-full custom-hover rounded-xl">
            <div className="relative w-full h-full md:h-56 lg:h-64">
              <img
                src="/skill/workplace.png"
                alt=""
                className="max-h-auto bg-contain bg-center w-full h-full md:w-full md:h-full"
              />
              <p className="absolute text-xs bottom-0 p-5 xl:text-xl text-white font-light md:text-lg">
                Managing Your Workforce, So You Can Focus on Growth
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-5 md:grid-cols-4 w-full py-14 px-5">
        <div className="flex flex-col items-center px-5">
          <div className="h-20 w-20 md:h-24 md:w-24 border-[4px] rounded-full border-[#FF7E00] p-1 bg-transparent">
            <div className="h-full w-full bg-[#182152] rounded-full flex items-center justify-center">
              <img
                src="/consulting/hassle-free-hiring.svg"
                alt=""
                className="w-10 h-10"
              />
            </div>
          </div>
          <h6 className="pt-2 text-xl md:text-2xl text-center max-w-32 ">
            Hassle-Free Hiring
          </h6>
          <p className="text-xs text-center pt-2 xl:text-base max-w-48">
            We handle the entire recruitment process so you can focus on your
            business.
          </p>
        </div>
        <div className="flex flex-col items-center px-5">
          <div className="h-20 w-20 md:h-24 md:w-24 border-[4px] rounded-full border-[#FF7E00] p-1 bg-transparent">
            <div className="h-full w-full bg-[#182152] rounded-full flex items-center justify-center">
              <img
                src="/consulting/top-talent.svg"
                alt=""
                className="w-10 h-10"
              />
            </div>
          </div>
          <h6 className="pt-2 text-xl md:text-2xl text-center max-w-32">
            Top Talent Guaranteed
          </h6>
          <p className="text-xs text-center pt-2 xl:text-base max-w-48">
            Access a pool of skilled professionals tailored to your industry.
          </p>
        </div>
        <div className="flex flex-col items-center px-5">
          <div className="h-20 w-20 md:h-24 md:w-24 border-[4px] rounded-full border-[#FF7E00] p-1 bg-transparent">
            <div className="h-full w-full bg-[#182152] rounded-full flex items-center justify-center">
              <img
                src="/consulting/cost-effective.svg"
                alt=""
                className="w-10 h-10"
              />
            </div>
          </div>
          <h6 className="pt-2 text-xl md:text-2xl text-center max-w-32">
            Cost-Effective Solutions
          </h6>
          <p className="text-xs text-center pt-2 xl:text-base max-w-48">
            Save time and resources with our streamlined workforce management.
          </p>
        </div>
        <div className="flex flex-col items-center px-5">
          <div className="h-20 w-20 md:h-24 md:w-24 border-[4px] rounded-full border-[#FF7E00] p-1 bg-transparent">
            <div className="h-full w-full bg-[#182152] rounded-full flex items-center justify-center">
              <img
                src="/consulting/flexibility-scalability.svg"
                alt=""
                className="w-10 h-10"
              />
            </div>
          </div>
          <h6 className="pt-2 text-xl md:text-2xl text-center max-w-32">
            Flexibility and Scalability
          </h6>
          <p className="text-xs text-center pt-2 xl:text-base max-w-48">
            Scale your workforce up or down as per your business needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseStaff;
